'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CardComponent } from './component';
import { LKIcon } from '../icon/module';
import { LKId } from '../id/module';

@NgModule({
  imports     : [
    BrowserModule,
    LKIcon,
    LKId
  ],
  declarations: [CardComponent],
  exports     : [CardComponent]
})
export class LKCard {
}
